import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Merge class names with clsx, then resolve Tailwind conflicts with
 * tailwind-merge (last-wins). The standard design-system class combiner.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs))
}

/**
 * Neutral icon-button tone — a gray-500 glyph that darkens to gray-600 over a
 * gray-100 hover background. The shared skin for low-emphasis icon triggers
 * (`CloseButton`'s default tone, the `HelpPopover` trigger) so they can't drift
 * apart. Consumers layer their own base/focus/size classes on top via `cn`.
 */
export const neutralIconTone =
  'text-fbui-gray-500 hover:bg-fbui-gray-100 hover:text-fbui-gray-600'
